export const activeSessions = {
  name: '使用中時段 |||| 使用中時段',
  fields: {
    id: '時段編號',
    app_session_id: 'App 時段編號',
    transaction_id: '交易編號',
    user_id: '用戶編號',
    charger_id: '充電器編號',
    connector_id: '連接器編號',
    charger_name: '充電器名稱',
    site_name: '站點名稱',
    status: '狀態',
    start_timestamp: '開始時間',
    charging_completed_at: '充電完成時間',
    duration_seconds: '持續時間',
    energy_delivered: '已輸送電量',
    current_power: '目前功率',
    meter_value: '電量讀數',
    estimated_kwh: '預估 kWh',
    pre_auth_amount: '預授權金額',
    estimated_cost: '預估費用',
    final_cost: '最終費用',
    last_meter_update: '最後更新',
    estimated_completion: '預估完成時間',
    created_at: '建立時間',
    updated_at: '更新時間',
  },
  statuses: {
    initiating: '啟動中',
    charging: '充電中',
    completing: '完成中',
    completed: '已完成',
    failed: '失敗',
  },
  filters: {
    search: '搜尋',
    status: '狀態',
    type: '類型',
    user_id: '用戶編號',
    charger_id: '充電器編號',
    site_id: '站點編號',
    site: '站點',
    charger: '充電器',
    fromDate: '開始日期',
    toDate: '結束日期',
  },
  types: {
    app: 'App',
    rfid: 'RFID',
    admin: '管理員',
    ocpp: 'OCPP',
    backend_standalone: '後台',
    backend_on_behalf: '代客充電',
    vendor_api: '供應商 API',
    kiosk: 'Kiosk',
  },
  details: {
    session_info: '時段資訊',
    charging_progress: '充電進度',
    charger_location: '充電器與位置',
    user_info: '用戶資訊',
    cost_info: '費用資訊',
    current_power: '目前功率',
    duration: '持續時間',
    estimated_cost: '預估費用',
    energy_progress: '電量進度',
    live: '即時',
    auto_refresh: '每 30 秒自動重新整理 • 最後更新',
    still_charging: '充電中...',
    target: '目標',
    delivered: '已輸送',
  },
  actions: {
    refresh: '重新整理',
    manualStart: '手動啟動',
    stopSession: '停止時段',
    forceComplete: '強制完成',
  },
  manualStart: {
    title: '手動啟動充電時段',
    sessionMode: '時段模式',
    onBehalf: '代理模式（含結算）',
    standalone: '獨立模式（無結算）',
    onBehalfDescription: '代表用戶啟動時段。費用將從用戶錢包扣除。',
    standaloneDescription: '啟動獨立時段用於測試或維護。不進行付款結算。',
    searchUser: '搜尋用戶',
    searchUserPlaceholder: '輸入姓名或電郵搜尋...',
    lookupByPhone: '以電話號碼查找客戶',
    phonePlaceholder: '例如：12345678',
    lookup: '查找',
    phoneNotFound: '找不到對應此電話號碼的客戶',
    confirmCustomer: '請與客戶確認這是同一人：',
    name: '姓名',
    email: '電郵',
    phone: '電話',
    site: '站點',
    sitePlaceholder: '選擇站點...',
    charger: '充電器',
    chargerPlaceholder: '選擇充電器...',
    chargerPlaceholderNoSite: '請先選擇站點',
    connector: '連接器',
    connectorPlaceholder: '選擇連接器...',
    estimatedKwh: '預估 kWh',
    estimatedKwhHelp: '此時段所需的預估電量',
    createPreAuth: '建立錢包預授權',
    createPreAuthHelp: '充電開始前在用戶錢包中預留資金',
    adminNotes: '管理員備註',
    adminNotesPlaceholder: '記錄此手動時段的原因（選填）...',
    adminNotesHelp: '選填備註以記錄此手動時段的原因',
    cancel: '取消',
    startSession: '啟動時段',
    starting: '啟動中...',
    status: '狀態',
    connectorStatus: '連接器',
    connectors: '連接器',
    // Validation errors
    errorSelectSite: '請選擇站點',
    errorSelectCharger: '請選擇充電器',
    errorSelectUser: '代理模式需選擇用戶',
    errorInvalidKwh: '預估 kWh 必須大於 0',
    // Notifications
    successOnBehalf: '已成功代表用戶啟動充電時段',
    successStandalone: '已成功啟動獨立充電時段',
    errorStartSession: '啟動充電時段失敗',
    errorLoadSites: '載入站點失敗',
    errorLoadChargers: '載入充電器失敗',
    errorSearchUsers: '搜尋用戶失敗',
    warningNoChargers: '此站點沒有可用的充電器',
  },
  list: {
    title: '充電時段監控',
    session: '時段',
    user: '用戶',
    site: '站點',
    charger: '充電器',
    startTime: '開始時間',
    type: '類型',
    status: '狀態',
    actions: '操作',
    activeSessions: '使用中時段',
  },
  show: {
    title: '使用中時段詳情',
    sessionNumber: '時段',
    chargingProgress: '充電進度',
    sessionInfo: '時段資訊',
    chargerLocation: '充電器與位置',
    userInfo: '用戶資訊',
    costInfo: '費用資訊',
    sessionId: '時段編號',
    transactionId: '交易編號',
    status: '狀態',
    startTime: '開始時間',
    stopTime: '停止時間',
    lastUpdate: '最後更新',
    chargerName: '充電器名稱',
    chargerId: '充電器編號',
    connectorId: '連接器編號',
    siteName: '站點名稱',
    chargerPower: '充電器功率',
    connectorType: '連接器類型',
    userId: '用戶編號',
    name: '姓名',
    email: '電郵',
    phone: '電話',
    vehicles: '車輛',
    primary: '主要',
    preAuthAmount: '預授權金額',
    currentEstimatedCost: '目前預估費用',
    finalCost: '最終費用',
    notFinalized: '尚未確定',
    meterReading: '電量讀數',
    kwh: 'kWh',
    kwhDelivered: 'kWh 已輸送',
    currentVoltage: '目前電壓',
    currentAmps: '目前電流（安培）',
    batterySoc: '電池電量',
    estimatedCompletion: '預估完成時間',
  },
};
